<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Productdetails" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default" style="display: block;">
          <h6>Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm</h6>
        </div>
          <div class="block-content">
            <form  onsubmit="return false">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Barcode">Barcode:</label>
                        <input v-model="product.gtin" type="text" class="form-control form-control-lg" id="Barcode">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Location">Locatie:</label>
                        <input v-model="product.location" type="text" class="form-control form-control-lg" id="Location">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ProductTitle">Naam:</label>
                        <input v-model="product.name" type="text" class="form-control form-control-lg" id="ProductTitle">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Quantity">Aantal:</label>
                        <input v-model="product.stock_quantity" type="number" class="form-control form-control-lg" id="Quantity">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Brand">Merk:</label>
                        <multiselect v-model="product.brand" :options="brands" placeholder="Selecteer een leverancier" selected-label="✔" select-label="" deselect-label="✔" allow-input/>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Price">Prijs:</label>
                        <input v-model="product.price" type="number" class="form-control form-control-lg" id="Price">
                    </div>
                </div>
                <button @click="createProduct" type="submit" class="btn btn-primary btn-lg">Opslaan</button>
            </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'
export default {
  components: {},
  data () {
    return {
      brands: [],

      product: {
        gtin: null,
        name: null,
        brand: null,
        location: null,
        stock_quantity: 0,
        price: 0
      }
    }
  },
  methods: {
    loadBrands () {
      http.get('brands')
      .then((result) => {
        this.brands = result.data.data
      })
    },
    createProduct () {
      this.$http.post(`/product`, this.product)
        .then((response) => {
          const product = response.data.data
          this.$swal('Hoera 😊', `Het product is succesvol aangemaakt.`, 'success')
          this.$emit('created', { product })
          this.$refs.modal.hide()
        })
      .catch(() => {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.`, 'error')
      })
    }
  },
  created () {
    this.loadBrands()
  }
}
</script>




// WEBPACK FOOTER //
// CreateProductModal.vue?3b163fa8